<template>
  <div>
    <!-- Account Settings Tabs -->
    <b-tabs
      vertical
      content-class="col-12 col-md-9 mt-1 mt-md-0"
      pills
      nav-wrapper-class="col-md-3 col-12"
      nav-class="nav-left"
    >

      <!-- general tab -->
      <b-tab active>

        <!-- title -->
        <template #title>
          <feather-icon
            icon="UserIcon"
            size="18"
            class="mr-50"
          />
          <span class="font-weight-bold">General</span>
        </template>

        <account-setting-general
          v-if="options.general"
          :general-data="options.general"
        />
      </b-tab>
      <!--/ general tab -->

      <!-- change password tab -->
      <b-tab>

        <!-- title -->
        <template #title>
          <feather-icon
            icon="LockIcon"
            size="18"
            class="mr-50"
          />
          <span class="font-weight-bold">Change Password</span>
        </template>

        <account-setting-password />
      </b-tab>
      <!--/ change password tab -->

      <!-- permissions tab -->
      <b-tab v-if="false">

        <!-- title -->
        <template #title>
          <feather-icon
            icon="ShieldIcon"
            size="18"
            class="mr-50"
          />
          <span class="font-weight-bold">My Permissions</span>
        </template>

        <account-setting-permissions />
      </b-tab>
      <!--/ permissions tab -->

      <!-- notification -->
      <b-tab>

        <!-- title -->
        <template #title>
          <feather-icon
            icon="MailIcon"
            size="18"
            class="mr-50"
          />
          <span class="font-weight-bold">Email Preferences</span>
        </template>

        <account-setting-email-address
          v-if="options.general"
          :general-data="options.general"
          @email-change-pending="updateEmailChange"
          @email-changed="updateEmailChange"
        />

        <account-setting-notification
          v-if="options.notification"
          :notification-data="options.notification"
        />
      </b-tab>
      <b-tab>
        <template #title>
          <feather-icon
            icon="TrashIcon"
            size="18"
            class="mr-50"
          />
          <span class="font-weight-bold">Delete Account</span>
        </template>

        <account-setting-delete-account />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import {
  BTabs,
  BTab,
} from 'bootstrap-vue'
import AccountSettingGeneral from './pages/account-details/AccountSettingGeneral.vue'
import AccountSettingPassword from './pages/account-details/AccountSettingPassword.vue'
import AccountSettingNotification from './pages/account-details/AccountSettingNotification.vue'
import AccountSettingPermissions from './pages/account-details/AccountSettingPermissions.vue'
import AccountSettingDeleteAccount from './pages/account-details/AccountSettingDeleteAccount.vue'
import AccountSettingEmailAddress from './pages/account-details/AccountSettingEmailAddress.vue'

export default {
  components: {
    BTabs,
    BTab,
    AccountSettingGeneral,
    AccountSettingPassword,
    AccountSettingNotification,
    AccountSettingPermissions,
    AccountSettingDeleteAccount,
    AccountSettingEmailAddress,
  },
  data() {
    return {
      options: {
        general: {
          fullName: '',
          fca: '',
          companyName: '',
          company: '',
          telephone: '',
          email: '',
          pendingEmail: '',
          pendingEmailExpired: false,
          allowedEmailSuffixes: [],
          emailChangeUnavailableReason: 'Loading company email addresses...',
        },
        notification: {
          reportFrequency: 'AllEmails',
          commentOnArticle: true,
          AnswerOnForm: true,
          followMe: false,
          newAnnouncements: true,
          productUpdates: false,
          blogDigest: false,
        },
      },
    }
  },
  mounted() {
    this.loadUserData()
  },
  methods: {
    updateEmailChange(pending) {
      Object.assign(this.options.general, pending)
    },
    loadUserData() {
      this.$http
        .get('account.cfc', {
          params: {
            method: 'getUserLogin',
          },
        })
        .then(response => {
          if (response.data.success && response.data.data) {
            // Populate general information
            this.options.general = {
              fullName: response.data.data.fullName || '',
              fca: response.data.data.fca || '',
              companyName: response.data.data.companyName || '',
              company: response.data.data.company || '',
              telephone: response.data.data.telephone || '',
              email: response.data.data.email || '',
              pendingEmail: response.data.data.pendingEmail || '',
              pendingEmailExpired: response.data.data.pendingEmailExpired || false,
              allowedEmailSuffixes: response.data.data.allowedEmailSuffixes || [],
              emailChangeUnavailableReason: response.data.data.emailChangeUnavailableReason || '',
            }

            // Populate notification settings
            if (response.data.data.reportFrequency) {
              this.options.notification.reportFrequency = response.data.data.reportFrequency
            }
            if (response.data.data.emailPromotions !== undefined) {
              this.options.notification.emailPromotions = response.data.data.emailPromotions
            }
            if (response.data.data.emailHubUpdates !== undefined) {
              this.options.notification.emailHubUpdates = response.data.data.emailHubUpdates
            }
            if (response.data.data.emailPremiumUpdates !== undefined) {
              this.options.notification.emailPremiumUpdates = response.data.data.emailPremiumUpdates
            }
          } else {
            this.options.general.emailChangeUnavailableReason = 'Account details could not be loaded. Please refresh the page.'
          }
        })
        .catch(() => {
          this.options.general.emailChangeUnavailableReason = 'Account details could not be loaded. Please refresh the page.'
          this.$bvToast.toast('Failed to load account data. Please refresh the page.', {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })
        })
    },
  },
}
</script>
